<template>
  <v-switch
    inset
    v-model="localHighContrastEnabled"
    :true-icon="'mdi-brightness-3'"
    :false-icon="'mdi-brightness-5'"
    :class="{
      'contrast-switch-on': !localHighContrastEnabled,
      'contrast-switch-off': localHighContrastEnabled,
    }"
  >
    <template v-slot:label v-if="showLabel">
      {{
        !localHighContrastEnabled
          ? t('accessibilitySettings.contrastModeLow')
          : t('accessibilitySettings.contrastModeHigh')
      }}
    </template>
  </v-switch>
</template>

<script>
import { useTheme } from "vuetify";
import { mapState, mapActions } from "vuex";
import { useI18n } from 'vue-i18n';

export default {
  props: {
    showLabel: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data() {
    return {
      localHighContrastEnabled: false,
      theme: useTheme(),
    };
  },
  watch: {
    localHighContrastEnabled() {
      this.updateContrast(this.localHighContrastEnabled);
      this.theme.global.name = this.localHighContrastEnabled
        ? "darkTheme"
        : "lightTheme";
    },
  },
  created() {
    this.localHighContrastEnabled = this.highContrastEnabled;
    this.$vuetify.theme.themes.light =
    this.$vuetify.theme.themes["lightTheme"];
    this.$vuetify.theme.themes.dark =
    this.$vuetify.theme.themes["darkTheme"];
    this.theme.global.name = this.localHighContrastEnabled
      ? "darkTheme"
      : "lightTheme";
  },
  computed: {
    ...mapState(["highContrastEnabled"]),
  },
  methods: {
    ...mapActions(["updateContrast"]),
    updateContrastSetting() {
      
    }
  },
};
</script>

<style>
.contrast-switch-on,
.contrast-switch-off {
  --v-switch-track-height: 24px;
  --v-switch-thumb-size: 24px;
  --v-switch-track-width: 48px;
  transform: scale(1.25);
  transform-origin: left center;
  margin: 0;
  margin-left: 32px;
  width: 100%;
}

/* .contrast-switch-on .v-label,
.contrast-switch-off .v-label {
  font-size: 14px;
} */
.contrast-switch-on .mdi-volume-high,
.contrast-switch-on .mdi-brightness-5 {
  color: white;
  font-size: 14px;
  color: red;
}
.contrast-switch-off .mdi-volume-off,
.contrast-switch-off .mdi-brightness-3 {
  color: white;
  font-size: 14px;
  background: black;
}
.contrast-switch-off .v-switch__thumb {
  background: black;
}

@media (max-width: 768px) {
  .contrast-switch-on,
  .contrast-switch-off {
    transform: scale(1.25);
  }
}
</style>